import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LottieComponent } from 'ngx-lottie';
@Component({
  selector: 'app-loading',
  imports: [CommonModule, LottieComponent],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  @Input() message: string = 'Loading...';
  options = {
    path: '/lottie/loading.json',
    loop: true,
    autoplay: true,
  };
}
